import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

const districts = [
  "Araria",
  "Arwal",
  "Aurangabad",
  "Banka",
  "Begusarai",
  "Bhagalpur",
  "Bhojpur",
  "Buxar",
  "Darbhanga",
  "East Champaran",
  "Gaya",
  "Gopalganj",
  "Jamui",
  "Jehanabad",
  "Kaimur",
  "Katihar",
  "Khagaria",
  "Kishanganj",
  "Lakhisarai",
  "Madhepura",
  "Madhubani",
  "Munger",
  "Muzaffarpur",
  "Nalanda",
  "Nawada",
  "Patna",
  "Purnia",
  "Rohtas",
  "Saharsa",
  "Samastipur",
  "Saran",
  "Sheikhpura",
  "Sheohar",
  "Sitamarhi",
  "Siwan",
  "Supaul",
  "Vaishali",
  "West Champaran",
];

const impairmentTypes = [
  {
    label: "Loco motor Disability/लोको मोटर विकलांगता",
    value: "Loco motor disability",
  },
  {
    label: "Intellectual Disability/ बौद्धिक विकलांगता",
    value: "Intellectual disability",
  },
  { label: "Hearing Impairment/ श्रवण बाधित", value: "Hearing impairment" },
  { label: "Visually Impairment/ दृष्टिबाधित", value: "Visually impairment" },
  { label: "Cerebral Palsy/ मस्तिष्क पक्षाघात", value: "Cerebral palsy" },
  { label: "Multiple Disability/बहु विकलांगता", value: "Multiple disability" },
  { label: "Other/ अन्य", value: "Other" },
];

const participationGames = [
  { label: "Para Athletics/ पैरा एथलेटिक्स", value: "para athletics" },
  { label: "Para Badminton/ पैरा बैडमिंटन", value: "para badminton" },
  { label: "Para Swimming/ पैरा तैराकी", value: "para swimming" },
  { label: "Other/ अन्य", value: "other" },
];

const paraAthleticsOptions = [
  { label: "100m", value: "100m" },
  { label: "800m", value: "800m" },
  { label: "Shot Put/ गोला फेंक", value: "shot put" },
  { label: "Discus Throw/ डिस्कस थ्रो", value: "discus throw" },
  { label: "Javelin Throw/  जेवेलिन थ्रो ", value: "javelin throw" },
  { label: "Long Jump/ लॉन्ग जम्प", value: "long jump" },
  { label: "High Jump/ हाई जम्प", value: "high jump" },
  { label: "Club Throw/ क्लब थ्रो", value: "club throw" },
];

const paraSwimmingOptions = [
  {
    label: "25m Backstrokes/ 25 मीटर बैकस्ट्रोक",
    value: "25m backstrokes",
    gender: "any",
  },
  {
    label: "50m Freestyle (Male)/ 50 मीटर फ्रीस्टाइल (पुरुष)",
    value: "50m freestyle (male)",
    gender: "male",
  },
  {
    label: "50m Freestyle (Female)/ 50 मीटर फ्रीस्टाइल (महिला)",
    value: "50m freestyle (female)",
    gender: "female",
  },
];

const today = new Date().toISOString().split("T")[0];
const minDOB = new Date();
minDOB.setFullYear(minDOB.getFullYear() - 100); // reasonable lower bound
const maxDOB = new Date();
maxDOB.setFullYear(maxDOB.getFullYear() - 1);
const min18DOB = new Date();
min18DOB.setFullYear(min18DOB.getFullYear() - 18);

export default function ParaGamesForm() {
  const [form, setForm] = useState({
    name: "",
    fatherName: "",
    motherName: "",
    email: "",
    dateOfBirth: "",
    gender: "",
    contactNumber: "",
    schoolOrNgoName: "",
    district: "",
    pinCode: "",
    permanentAddress: "",
    correspondentAddress: "",
    sameAsPermanent: false,
    aadharCardNumber: "",
    disabilitySpecification: "",
    impairmentType: "",
    impairmentTypeOther: "",
    impairmentLossPercent: "",
    disabilityCertificateNumber: "",
    bankAccountHolderName: "",
    bankName: "",
    bankAccountNumber: "",
    ifscCode: "",
    participationInGames: "",
    paraAthleticsEvents: [],
    paraBadmintonEvent: "",
    paraSwimmingEvents: [],
    participationOther: "",
    categoryClassification: "",
    dateOfFormSubmission: today,
  });

  // For para swimming gender logic
  const [swimmingGender, setSwimmingGender] = useState({
    male: false,
    female: false,
  });

  //   handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // validation
    // if (!form.name || !form.fatherName || !form.motherName) {
    //   alert("Please fill required fields");
    // }
    // send data to localhost:5002/api/pararegistration/2025 as post request with form as requesuest body
    try {
      const response = await fetch(
        // "https://api.biharsports.org/api/pararegistration/2025",
        "http://localhost:5002/api/pararegistration/2025",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );
      const data = await response.json();
      if (data.success) {
        if (data?.data?.registrationId)
          alert(`Registration ID: ${data.data.registrationId}`);
        else alert("Form submitted successfully!");
        handleReset();
      } else {
        alert((data?.errors && JSON.stringify(data?.errors)) || data?.message || "problem in submitting data");
        // alert(data?.error || data?.message || "problem in submitting data");
      }
    } catch (error) {
      alert("Error submitting form: " + error.message);
    }
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "sameAsPermanent") {
      setForm((f) => ({
        ...f,
        sameAsPermanent: checked,
        correspondentAddress: checked ? f.permanentAddress : "",
      }));
    } else if (name === "paraAthleticsEvents") {
      let arr = [...form.paraAthleticsEvents];
      if (checked) {
        if (arr.length < 2) arr.push(value);
      } else {
        arr = arr.filter((v) => v !== value);
      }
      setForm((f) => ({ ...f, paraAthleticsEvents: arr }));
    } else if (name === "paraSwimmingEvents") {
      let arr = [...form.paraSwimmingEvents];
      if (checked) {
        // Prevent selecting both male and female
        if (
          (value === "50m freestyle (male)" &&
            arr.includes("50m freestyle (female)")) ||
          (value === "50m freestyle (female)" &&
            arr.includes("50m freestyle (male)"))
        ) {
          return;
        }
        if (arr.length < 2) arr.push(value);
      } else {
        arr = arr.filter((v) => v !== value);
      }
      setForm((f) => ({ ...f, paraSwimmingEvents: arr }));
    } else if (name === "permanentAddress" && form.sameAsPermanent) {
      setForm((f) => ({
        ...f,
        permanentAddress: value,
        correspondentAddress: value,
      }));
    } else if (name === "impairmentType") {
      setForm((f) => ({
        ...f,
        impairmentType: value,
        impairmentTypeOther: "",
      }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  //   handle reset
  const handleReset = () => {
    setForm({
      name: "",
      fatherName: "",
      motherName: "",
      email: "",
      dateOfBirth: "",
      gender: "",
      contactNumber: "",
      schoolOrNgoName: "",
      district: "",
      pinCode: "",
      permanentAddress: "",
      correspondentAddress: "",
      sameAsPermanent: false,
      aadharCardNumber: "",
      disabilitySpecification: "",
      impairmentType: "",
      impairmentTypeOther: "",
      impairmentLossPercent: "",
      disabilityCertificateNumber: "",
      bankAccountHolderName: "",
      bankName: "",
      bankAccountNumber: "",
      ifscCode: "",
      participationInGames: "",
      paraAthleticsEvents: [],
      paraBadmintonEvent: "",
      paraSwimmingEvents: [],
      categoryClassification: "",
      dateOfFormSubmission: today,
    });
  };

  // Validation helpers
  const isValidAadhaar = (v) => /^\d{12}$/.test(v);
  // const isValidIFSC = (v) => /^[A-Za-z]{4}\d{7}$/.test(v);
  const isValidIFSC = (v) => /^[A-Za-z0-9]{11}$/.test(v);
  const isValidPincode = (v) => /^\d{6}$/.test(v);
  const isValidPhone = (v) => /^\d{10}$/.test(v);

  return (
    <form
      style={{
        margin: "0 auto",
        padding: 24,
        background: "#f9f9f9",
        borderRadius: 8,
        maxWidth: 1000,
      }}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <div style={{ textAlign: "center", marginBottom: "10px", background: "#ff0", border:"2px solid black", width: "fit-content", margin: "0 auto", padding:"0.5%" }}>
        <b>Helpdesk Number: <a href="tel:+919031045385" style={{color:"#00f"}}>9031045385</a></b>
      </div>
      <h2>
        District Level Para Sports (Open for all age categories) Championship
        2025/ जिला स्तरीय पैरा स्पोर्ट्स (सभी आयु वर्ग के लिये) चैंपियनशिप 2025
      </h2>
      <p>
        (Event Date: 15 - 22 September, 2025/ आयोजन तिथि: 15 - 22 सितंबर, 2025)
      </p>
      <hr />
      <h3>Registration Form/ पंजीकरण फॉर्म</h3>
      <p>
        (Last date of form fillup-13th September, 2025)/ (फॉर्म भरने की अंतिम
        तिथि - 13 सितंबर, 2025)
      </p>
      <br />
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Name/नाम:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                pattern="[A-Za-z\s]+"
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Father's Name/ पिता का नाम:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="fatherName"
                value={form.fatherName}
                onChange={handleChange}
                pattern="[A-Za-z\s]+"
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Mother's Name/ माता का नाम:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="motherName"
                value={form.motherName}
                onChange={handleChange}
                pattern="[A-Za-z\s]+"
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Email ID/ ईमेल आईडी:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Date of Birth/ जन्म तिथि:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="date"
                name="dateOfBirth"
                value={form.dateOfBirth}
                onChange={handleChange}
                min={minDOB.toISOString().split("T")[0]}
                max={maxDOB.toISOString().split("T")[0]}
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Gender/ लिंग :<span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <select
                name="gender"
                value={form.gender}
                onChange={handleChange}
                required
                style={{ padding: "0.5%", width: "100%" }}
              >
                <option value="">Select</option>
                <option value="male">Male/ पुरुष</option>
                <option value="female">Female/ महिला</option>
              </select>
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Contact Number/ संपर्क संख्या:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="tel"
                name="contactNumber"
                value={form.contactNumber}
                onChange={handleChange}
                pattern="\d{10}"
                maxLength={10}
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                School or NGO Name/ विद्यालय या एनजीओ का नाम:
                <small style={{ color: "red" }}> (optional)</small>
                {/* <span style={{ color: "red" }}> *</span> */}
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="schoolOrNgoName"
                value={form.schoolOrNgoName}
                onChange={handleChange}
                // alphanumeric+ specials
                pattern="^[A-Za-z0-9\-\+\&\(\)\@\#\,\s]+$"
                // required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                District/ जिला:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <select
                name="district"
                value={form.district}
                onChange={handleChange}
                required
                style={{ padding: "0.5%", width: "100%" }}
              >
                <option value="">Select</option>
                {districts.map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                PIN Code/ पिन कोड:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="pinCode"
                value={form.pinCode}
                onChange={handleChange}
                pattern="\d{6}"
                maxLength={6}
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Permanent Address/ स्थायी पता:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="permanentAddress"
                value={form.permanentAddress}
                onChange={handleChange}
                pattern="[A-Za-z0-9\s,.-]+"
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2}></Col>
            <Col md={10} style={{ textAlign: "left" }}>
              <input
                type="checkbox"
                name="sameAsPermanent"
                checked={form.sameAsPermanent}
                onChange={handleChange}
                style={{ marginRight: 8 }}
              />
              Correspondent Address same as Permanent/पत्राचार का पता स्थायी पता
              के समान होने पर
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Correspondent Address/ पत्राचार का पता:
                <span style={{ color: "red" }}> *</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="correspondentAddress"
                value={form.correspondentAddress}
                onChange={handleChange}
                pattern="[A-Za-z0-9\s,.-]+"
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Aadhar Card Number/ आधार कार्ड नंबर :
                <span style={{ color: "red" }}>*</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="aadharCardNumber"
                value={form.aadharCardNumber}
                onChange={handleChange}
                pattern="\d{12}"
                maxLength={12}
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
              {!isValidAadhaar(form.aadharCardNumber) &&
                form.aadharCardNumber && (
                  <span style={{ color: "red" }}>Invalid Aadhaar</span>
                )}
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Disability Specification/ विकलांगता सम्बंधित विशेष विवरण:
                <span style={{ color: "red" }}> *</span>
              </span>
              {/* change pattern to  alphanumeric + special*/}
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="disabilitySpecification"
                value={form.disabilitySpecification}
                onChange={handleChange}
                pattern="^[A-Za-z\-\+\&\(\)\,\s]+$"
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Impairment Type/ क्षति का प्रकार:
                <span style={{ color: "red" }}>*</span>
              </span>
            </Col>
            <Col md={10}>
              <select
                name="impairmentType"
                value={form.impairmentType}
                onChange={handleChange}
                required
                style={{ padding: "0.5%", width: "100%" }}
              >
                <option value="">Select</option>
                {impairmentTypes.map((t, i) => (
                  <option key={i} value={t.value}>
                    {t.label}
                  </option>
                ))}
              </select>
              {form.impairmentType === "Other" && (
                <input
                  type="text"
                  name="impairmentTypeOther"
                  value={form.impairmentTypeOther}
                  onChange={handleChange}
                  placeholder="Please specify"
                  pattern="[A-Za-z\s]+"
                  required
                  style={{ width: "100%", marginTop: 4 }}
                />
              )}
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Impairment Loss (in %)/ क्षति का स्तर (% में):
                <span style={{ color: "red" }}>*</span>
              </span>
            </Col>
            <Col md={10}>
              <input
                type="number"
                name="impairmentLossPercent"
                value={form.impairmentLossPercent}
                onChange={handleChange}
                min={0}
                max={100}
                required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Disability Certificate/ UDID Card Number/ विकलांगता
                प्रमाणपत्र/यूडीआईडी कार्ड नंबर:
                <small>(optional)</small>
                {/* <span style={{ color: "red" }}>*</span> */}
              </span>
              {/* alphanumeric, specials */}
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="disabilityCertificateNumber"
                value={form.disabilityCertificateNumber}
                onChange={handleChange}
                pattern="^[A-Za-z0-9\-\+\&\(\)\,\@\#\s]+$"
                // required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <fieldset
          style={{
            border: "1px solid #ccc",
            padding: 10,
            margin: "10px 0",
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          <legend>Bank Account Details/ बैंक खाता का विवरण<small>{" "}(optional)</small></legend>
          <label>
            <Row>
              <Col md={2} style={{ textAlign: "left" }}>
                <span>
                  Bank Account Holder Name/ बैंक खाताधारक का नाम:
                  {/* <span style={{ color: "red" }}>*</span> */}
                </span>
              </Col>
              <Col md={10}>
                <input
                  type="text"
                  name="bankAccountHolderName"
                  value={form.bankAccountHolderName}
                  onChange={handleChange}
                  pattern="[A-Za-z\s]+"
                  // required
                  style={{ padding: "0.5%", width: "100%" }}
                />
              </Col>
            </Row>
          </label>
          <label>
            <Row>
              <Col md={2} style={{ textAlign: "left" }}>
                <span>
                  Bank Name/ बैंक का नाम:
                  {/* <span style={{ color: "red" }}>*</span> */}
                </span>
              </Col>
              <Col md={10}>
                <input
                  type="text"
                  name="bankName"
                  value={form.bankName}
                  onChange={handleChange}
                  pattern="[A-Za-z\s]+"
                  // required
                  style={{ padding: "0.5%", width: "100%" }}
                />
              </Col>
            </Row>
          </label>
          <label>
            <Row>
              <Col md={2} style={{ textAlign: "left" }}>
                <span>
                  Bank Account Number/ बैंक खाता संख्या:
                  {/* <span style={{ color: "red" }}>*</span> */}
                </span>
              </Col>
              <Col md={10}>
                <input
                  type="text"
                  name="bankAccountNumber"
                  value={form.bankAccountNumber}
                  onChange={handleChange}
                  pattern="\d+"
                  // required
                  style={{ padding: "0.5%", width: "100%" }}
                />
              </Col>
            </Row>
          </label>
          <label>
            <Row>
              <Col md={2} style={{ textAlign: "left" }}>
                <span>
                  IFSC Code/ आईएफएससी कोड:
                  {/* <span style={{ color: "red" }}>*</span> */}
                </span>
              </Col>
              <Col md={10}>
                <input
                  type="text"
                  name="ifscCode"
                  value={form.ifscCode}
                  onChange={handleChange}
                  pattern="^[A-Za-z0-9]{11}$"
                  maxLength={11}
                  // required
                  style={{ padding: "0.5%", width: "100%" }}
                />
                {!isValidIFSC(form.ifscCode) && form.ifscCode && (
                  <span style={{ color: "red" }}>Invalid IFSC</span>
                )}
              </Col>
            </Row>
          </label>
        </fieldset>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Participation in Games/ खेलों में भागीदारी:
                <span style={{ color: "red" }}>*</span>
              </span>
            </Col>
            <Col md={10}>
              <select
                name="participationInGames"
                value={form.participationInGames}
                onChange={handleChange}
                required
                style={{ padding: "0.5%", width: "100%" }}
              >
                <option value="">Select</option>
                {participationGames.map((g, i) => (
                  <option key={i} value={g.value}>
                    {g.label}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
        </label>
        {form.participationInGames === "para athletics" && (
          <div>
            <label style={{ marginBottom: 4 }}>
              <Row>
                <Col md={2}>
                  <span>
                    Para Athletics (max 2)Para Athletics/ पैरा एथलेटिक्स (अधिकतम
                    2 का चयन करें):
                  </span>
                </Col>
                <Col md={10}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {paraAthleticsOptions.map((opt, i) => (
                      <label
                        key={i}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          type="checkbox"
                          name="paraAthleticsEvents"
                          value={opt.value}
                          checked={form.paraAthleticsEvents.includes(opt.value)}
                          onChange={handleChange}
                          disabled={
                            !form.paraAthleticsEvents.includes(opt.value) &&
                            form.paraAthleticsEvents.length >= 2
                          }
                          style={{ marginRight: 4 }}
                        />
                        {opt.label}
                      </label>
                    ))}
                  </div>
                </Col>
              </Row>
            </label>
          </div>
        )}
        {form.participationInGames === "para badminton" && (
          <label>
            <Row>
              <Col md={2}>
                <span>Para Badminton/ पैरा बैडमिंटन:</span>
              </Col>
              <Col md={10}>
                <select
                  name="paraBadmintonEvent"
                  value={form.paraBadmintonEvent}
                  onChange={handleChange}
                  required
                  style={{ padding: "0.5%", width: "100%" }}
                >
                  <option value="">Select</option>
                  <option value="single (male)">
                    Single (Male)/ एकल (पुरुष)
                  </option>
                  <option value="single (female)">
                    Single (Female)/ एकल (महिला)
                  </option>
                </select>
              </Col>
            </Row>
          </label>
        )}
        {form.participationInGames === "para swimming" && (
          <div>
            <label style={{ marginBottom: 4 }}>
              <Row>
                <Col md={2}>
                  <span>
                    Para Swimming (max 2, cannot select male & female together)/
                    पैरा तैराकी ((अधिकतम 2, पुरुष और महिला में से किसी एक को ही
                    चुनें)):
                  </span>
                </Col>
                <Col md={10}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {paraSwimmingOptions.map((opt) => (
                      <label
                        key={opt.value}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          type="checkbox"
                          name="paraSwimmingEvents"
                          value={opt.value}
                          checked={form.paraSwimmingEvents.includes(opt.value)}
                          onChange={handleChange}
                          disabled={
                            (!form.paraSwimmingEvents.includes(opt.value) &&
                              form.paraSwimmingEvents.length >= 2) ||
                            (opt.value === "50m freestyle (male)" &&
                              form.paraSwimmingEvents.includes(
                                "50m freestyle (female)"
                              )) ||
                            (opt.value === "50m freestyle (female)" &&
                              form.paraSwimmingEvents.includes(
                                "50m freestyle (male)"
                              ))
                          }
                          style={{ marginRight: 4 }}
                        />
                        {opt.label}
                      </label>
                    ))}
                  </div>
                </Col>
              </Row>
            </label>
          </div>
        )}
        {form.participationInGames === "other" && (
          <input
            type="text"
            name="participationOther"
            value={form?.participationOther}
            onChange={handleChange}
            placeholder="Please specify"
            pattern="[A-Za-z\s]+"
            required
            style={{ width: "100%", marginTop: 4 }}
          />
        )}
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>
                Category/Classification/ श्रेणी/वर्गीकरण <small>(Optional)</small>:
                {/* <span style={{ color: "red" }}>*</span> */}
              </span>
              {/* alphanumeric, specials */}
            </Col>
            <Col md={10}>
              <input
                type="text"
                name="categoryClassification"
                value={form.categoryClassification}
                onChange={handleChange}
                // alphanumeric + special chars and brackets also
                pattern="^[A-Za-z0-9\-\+\&\(\)\@\#\,\s]+$"
                // required
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <label>
          <Row>
            <Col md={2} style={{ textAlign: "left" }}>
              <span>Date of Form Submission/ फॉर्म जमा करने की तिथि:</span>
            </Col>
            <Col md={10}>
              <input
                type="date"
                name="dateOfFormSubmission"
                value={form.dateOfFormSubmission}
                readOnly
                style={{ padding: "0.5%", width: "100%" }}
              />
            </Col>
          </Row>
        </label>
        <Row>
          <Col md={6}>
            <button
              type="submit"
              style={{
                marginTop: 16,
                background: "#007bff",
                color: "#fff",
                padding: "8px 16px",
                border: "none",
                borderRadius: 400,
                cursor: "pointer",
                width: "100%",
              }}
            >
              Submit
            </button>
          </Col>
          <Col md={6}>
            <button
              type="reset"
              style={{
                marginTop: 16,
                background: "#ff7b00",
                color: "#fff",
                padding: "8px 16px",
                border: "none",
                borderRadius: 400,
                cursor: "pointer",
                width: "100%",
              }}
            >
              Reset
            </button>
          </Col>
        </Row>
      </div>
    </form>
  );
}
